export enum TransactionFormType {
  Classic = 'Classic',
  FastOrder = 'FastOrder',
}

export interface iPreviewData {
  formId?: string;
  orderid?: string;
  symbol: string;
  orderType: string;
  configType: number;
  gtc: number;
  price: number;
  shares: number;
  triggerPrice: number | null;
  type: string;
  availableLot: number;
  multiAmendOrders?: {
    orderid: string;
    shares: number;
  }[];
  isSplitOrderActive: boolean;
  splitQuantity: number | null;
  splitRangeMin: number | null;
  splitRangeMax: number | null;
  multiplier?: string;
  isDayTrade?: boolean;
  companyType: string;
  trailingStop?: {
    percentage: number;
    initialStopPrice: number;
  };
}
